import { Button, Checkbox, Col, Form, Modal, Row, Typography } from "antd";
import Icons from "assets/icons";
import { InputFields } from "components/common";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { dataFieldsMap, treatDirection } from "./config";
import PrintBBHC from "../PrintBBHC/PrintBBHC";
import dayjs from "dayjs";
import { medicalExaminationService } from "api";

import {
  birthday2Age,
  convertIosStringToDate,
  convertIosStringToDate2,
  convertIosStringToDateObjectDayjs,
} from "helper/common";
import { inpatientService } from "api";
import { residentialNurseService } from "api";
import TextArea from "antd/es/input/TextArea";
import "./Consultation.scss";
import { listExamination } from "api";

const Consultation = React.forwardRef((props: any, ref) => {
  const { data } = props;
  const initialValues = {
    ngayPhauThuat: dayjs(),
    thoiGianDieuTriTu:
      convertIosStringToDateObjectDayjs(data?.ngayNhapVien) ?? dayjs(),
    thoiGianDieuTriDen:
      convertIosStringToDateObjectDayjs(data?.ngayNhapVien) ?? dayjs(),
    thoiGianHoiChan:
      convertIosStringToDateObjectDayjs(data?.ngayNhapVien) ?? dayjs(),
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [form] = Form.useForm();
  const [isView, setIsView] = useState<boolean>(false);
  //Disable hướng điều trị khi nhấn checck box
  const [isDisabled, setIsDisable] = useState<boolean>(false);
  const [icdList, setIcdList] = useState<any>([]);
  const [type, setType] = useState<number>(0);
  const [idx, setIdx] = useState<any>(null);
  const [thongTinBN, setThongTinBN] = useState<any>(null);
  console.log("🚀 ~ Consultation ~ thongTinBN:", thongTinBN);

  const [print, setPrint] = useState<boolean>(false);
  const [checked, setChecked] = useState(false);
  const printRef = useRef<any>();

  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleOnClick = async () => {
    if (checked === false) {
      form.setFieldValue("khac", null);
    }
    await props.onSave(type, idx);
    closeModal();
  };
  const getIcdList = async () => {
    const response = await medicalExaminationService.getIcdList();
    setIcdList(response.data);
  };
  useImperativeHandle(ref, () => ({
    setPrint: setPrint,
    openModal: (isView) => {
      if (isView === true) {
        setType(2);
        setIsView(true);
      } else if (isView === false) {
        setIsView(false);
        setType(1);
      } else {
        setType(0);
        setIsView(false);
      }
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    getValue: form.getFieldValue,
    getValues: form.getFieldsValue,
    setValue: form.setFieldValue,
    setValues: (data) => {
      form.setFieldsValue({
        ...data,
        thoiGianDieuTriTu: data.thoiGianDieuTriTu
          ? convertIosStringToDate2(data.thoiGianDieuTriTu)
          : null,
        thoiGianDieuTriDen: data.thoiGianDieuTriDen
          ? convertIosStringToDate2(data.thoiGianDieuTriDen)
          : null,
        thoiGianHoiChan: data.thoiGianHoiChan
          ? convertIosStringToDate2(data.thoiGianHoiChan)
          : null,
        ngayPhauThuat: convertIosStringToDate2(data.ngayPhauThuat),
        thanhPhanThamGia: data.thanhPhanThamGia,
      });
    },
    resetFields: form.resetFields,
    setIdx: setIdx,
    setThongTinBN: setThongTinBN,
    setIcdList: setIcdList,
    resetToNew: (thongTinBN) => {
      form.resetFields();
      setThongTinBN({
        ...thongTinBN,
      });
    },
  }));

  const [dmBuong, setDmBuong] = useState<any>([]);
  const [dmGiuong, setDmGiuong] = useState<any>([]);
  const fetchDanhMucGiuongBenh = async (params) => {
    try {
      let response = await inpatientService.getListDanhMucGiuongBenh(params);
      setDmGiuong(response.data);
    } catch (err) {}
  };
  const fetchDanhMucPhongBenh = async (params) => {
    try {
      let response = await inpatientService.getListDanhMucPhongBenh(params);
      setDmBuong(response.data);
    } catch (err) {}
  };
  const [dmPPPT, setDmPPPT] = useState<any>([]);
  const fetchListDmPPPT = async (params) => {
    try {
      let response = await listExamination.getByIdNDV(params);
      setDmPPPT(response.data);
    } catch (err) {}
  };
  const [listSurgeryStaff, setListSurgeryStaff] = useState<any>([]);
  const getLitSurgeryStaff = async () => {
    try {
      const res = await residentialNurseService.getLitSurgeryStaff();
      setListSurgeryStaff(
        res.find((it) => it.name === "bacSiPhauThuat") ?? null
      );
    } catch (err) {}
  };
  useEffect(() => {
    fetchDanhMucGiuongBenh({ page: 1, limit: 100 });
    fetchDanhMucPhongBenh({ page: 1, limit: 100 });
    getLitSurgeryStaff();
    getIcdList();
    fetchListDmPPPT({ idNhomDichVu: 2 });
  }, []);
  useEffect(() => {
    if (thongTinBN) {
      const res = printRef.current?.setData({ ...thongTinBN });
      form.setFieldsValue({
        hoVaTen: thongTinBN.tenBenhNhan,
        tuoi: thongTinBN.ngaySinh ? birthday2Age(thongTinBN.ngaySinh) : null,
        gioiTinh: thongTinBN.gioiTinh,
        diaChi: thongTinBN.diaChi,
        buong: thongTinBN.idBuongSo,
        giuong: thongTinBN.idGiuongSo,
        idBenhVaoVien: thongTinBN.icdChanDoan,
        benhVaoVien: thongTinBN.chanDoan,
        idBenhHoiChan: thongTinBN.icdChanDoan,
        benhHoiChan: thongTinBN.chanDoan,
        thanhPhanThamGia:
          thongTinBN?.thanhPhanThamGia ?? "Các bác sĩ trong khoa",
      });
      if (print) {
        printRef.current.setData([]);
        printRef.current.setData({
          ...(thongTinBN ?? {}),
          ...(form.getFieldsValue() ?? {}),
        });
      }
      if (thongTinBN?.khac && type != 2) {
        setIsDisable(true);
        setChecked(true);
      }
    }
  }, [thongTinBN]);

  return (
    <div className="modal">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        title={"Biên bản hội chẩn"}
        destroyOnClose={true}
        width={print ? 1000 : 1800}
        forceRender={true}
      >
        {print ? (
          <Row justify={"center"}>
            <PrintBBHC
              closeModal={closeModal}
              data={{ ...thongTinBN, ...form.getFieldsValue() }}
              ref={printRef}
              dmBuong={dmBuong}
              dmGiuong={dmGiuong}
              dmPPPT={dmPPPT}
            />
          </Row>
        ) : (
          <Row>
            <Row>
              <Form form={form} initialValues={initialValues}>
                <Row gutter={[6, 8]}>
                  <InputFields
                    data={dataFieldsMap(
                      icdList,
                      form,
                      isView,
                      dmBuong,
                      dmGiuong
                    )}
                  />
                  <Row>
                    <Typography.Text strong>
                      Hướng điều trị tiếp theo
                    </Typography.Text>
                  </Row>
                  <InputFields
                    data={treatDirection(
                      form,
                      listSurgeryStaff,
                      dmPPPT,
                      isView
                      // isDisabled
                    )}
                  />
                  <Row>
                    <Col
                      flex={"10px"}
                      style={{ margin: "auto", padding: "0 8px 0 0" }}
                    >
                      <Checkbox
                        onChange={(e) => {
                          setIsDisable(!isDisabled);
                          // if (e.target.checked) {
                          //   form.setFieldValue("ngayPhauThuat", null);
                          // } else form.setFieldValue("ngayPhauThuat", dayjs());
                          setChecked(e.target.checked);
                        }}
                        disabled={type === 2}
                        checked={checked}
                      />
                    </Col>
                    <Col flex={"auto"}>
                      <Form.Item
                        name="khac"
                        label="Khác"
                        labelCol={{ xl: 3, className: "label-col" }}
                        labelAlign="left"
                        wrapperCol={{ flex: "auto" }}
                        style={{ margin: "auto" }}
                      >
                        <TextArea disabled={!isDisabled || type === 2} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Row>
              </Form>
            </Row>
            <Row justify={"end"} style={{ gap: "4px", marginTop: "4px" }}>
              <Button
                type="primary"
                icon={<Icons.close />}
                danger
                onClick={closeModal}
              >
                Hủy
              </Button>

              <Button
                type="primary"
                icon={<Icons.save />}
                onClick={handleOnClick}
                disabled={isView}
              >
                Lưu
              </Button>
            </Row>
          </Row>
        )}
      </Modal>
    </div>
  );
});

export default Consultation;
